import React from 'react';
import PropTypes, { object } from 'prop-types';
import { PieChart, Pie, Cell } from 'recharts';
import cn from 'classnames';

import { colorsNew } from 'components/common/charts/helpers/config';

import classes from './DonutNew.module.scss';

const DonutNew = ({ data = [], chartColor, className }) => {
  if (data.length === 0) {
    const empty = [{ name: '', percent: 100 }];
    return (
      <PieChart width={123} height={123}>
        <Pie
          data={empty}
          innerRadius={45}
          outerRadius={61}
          dataKey="percent"
          blendStroke
        >
          <Cell fill="#dde6f2" />
        </Pie>
      </PieChart>
    );
  }

  return (
    <PieChart width={123} height={123} className={cn(classes.box, className)}>
      <Pie
        data={data}
        innerRadius={45}
        outerRadius={61}
        dataKey="percent"
        blendStroke
      >
        {data.map((entry, index) => (
          <Cell
            key={`${entry.name}-${index}`}
            fill={
              chartColor
                ? chartColor[entry.name]
                  ? chartColor[entry.name]
                  : colorsNew[index]
                : colorsNew[index]
            }
          />
        ))}
      </Pie>
    </PieChart>
  );
};

DonutNew.propTypes = {
  data: PropTypes.arrayOf(object),
  chartColor: PropTypes.object,
  className: PropTypes.string
};

export default DonutNew;
